var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 465.61 465.61",
    style: {
      enableBackground: "new 0 0 465.61 465.61"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "51.559,308.815 156.795,414.051 201.013,385.202 80.407,264.596  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.667,87.057 113.175,91.204 22.961,181.418 84.654,201.069  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.192,442.648 374.406,352.434 378.553,266.942 264.541,380.955  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.001,360.612L34,326.612l21.213,21.213l-33.999,33.999L0.001,360.612z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.992,465.61l-21.213-21.213l33.999-34l21.213,21.213L104.992,465.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.021,417.876l50.122-50.122l21.213,21.213l-50.122,50.122L25.021,417.876z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.939,
    cy: 100.67,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.967,10.643c-58.835-22.219-127.811-9.648-175.172,37.712L93.194,234.956l137.46,137.459l186.601-186.601 C464.615,138.454,477.185,69.478,454.967,10.643z M396.759,132.49c-17.574,17.573-46.066,17.573-63.64,0 c-17.574-17.574-17.574-46.066,0-63.64s46.066-17.574,63.64,0C414.332,86.424,414.332,114.917,396.759,132.49z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketIcon);
export default __webpack_public_path__ + "static/media/rocket-Icon.5aa6153d82c1457ac96f4d2d7477ab7c.svg";
export { ForwardRef as ReactComponent };